import { Component, Output, EventEmitter, ContentChildren, QueryList, AfterContentInit, Input } from '@angular/core';
import { WizardStepComponent } from './wizard-step.component';

@Component({
    selector: 'form-wizard',
    styleUrls: ['./wizzard-step.component.scss'],
    template:
        `
        <div class="row">
            <div class="col-md-12">
                <nav class="form-steps">
                    <ng-container *ngFor="let step of steps; let i = index">
                        <div class="form-steps-item" 
                            [ngClass]="{'form-steps-item--active': step.isActive, 'form-steps-item--active': !step.isDisabled, 'bg' : step.isDisabled}">
                            <div class="form-steps-item-content">
                                <span class="form-steps-item-icon">{{i + 1}} {{step.isDisabled}}</span>
                                <span *ngIf="i >= 1" class="form-steps-item-line"></span>
                                <span class="form-steps-item-text">{{step.title}}</span>
                            </div>
                        </div>
                    </ng-container>
                </nav>
            </div>
        </div>
        <div class="row padding-form">
            <div class="col-md-12">
                <ng-content></ng-content>
                <div [hidden]="isCompleted">
                    <button type="button" class="btn btn-light float-left" (click)="previous()" [hidden]="!hasPrevStep || !activeStep.showPrev">{{ prevLabel ? prevLabel : 'Anterior' }}</button>
                    <button type="button" class="btn btn-outline-primary w-100p mb-1 mr-1 float-right" (click)="next()" [disabled]="!activeStep.isValid" [hidden]="!hasNextStep || !activeStep.showNext">{{ nextLabel ? nextLabel : 'Próximo' }}</button>
                    <button type="button" class="btn btn-outline-success w-100p mb-1 mr-1 float-right" (click)="complete()" [disabled]="!activeStep.isValid" [hidden]="hasNextStep">{{ doneLabel ? doneLabel : 'Finalizar' }}</button>
                </div>
            </div>
        </div>
        `
})

export class WizardComponent implements AfterContentInit {
    @ContentChildren(WizardStepComponent)
    wizardSteps: QueryList<WizardStepComponent>;

    private _steps: Array<WizardStepComponent> = [];
    private _isCompleted = false;

    @Input() nextLabel: string;
    @Input() prevLabel: string;
    @Input() doneLabel: string;

    @Output() StepChanged: EventEmitter<WizardStepComponent> = new EventEmitter<WizardStepComponent>();

    constructor() { }

    ngAfterContentInit() {
        this.wizardSteps.forEach(step => this._steps.push(step));
        this.steps[0].isActive = true;
    }

    get steps(): Array<WizardStepComponent> {
        return this._steps.filter(step => !step.hidden);
    }

    get isCompleted(): boolean {
        return this._isCompleted;
    }

    get activeStep(): WizardStepComponent {
        return this.steps.find(step => step.isActive);
    }

    set activeStep(step: WizardStepComponent) {
        if (step !== this.activeStep && !step.isDisabled) {
            this.activeStep.isActive = false;
            step.isActive = true;
            this.StepChanged.emit(step);
        }
    }

    public get activeStepIndex(): number {
        return this.steps.indexOf(this.activeStep);
    }

    get hasNextStep(): boolean {
        return this.activeStepIndex < this.steps.length - 1;
    }

    get hasPrevStep(): boolean {
        return this.activeStepIndex > 0;
    }

    public goToStep(step: WizardStepComponent): void {
        if (!this.isCompleted) {
            this.activeStep = step;
        }
    }

    public next(): void {
        if (this.hasNextStep) {
            const nextStep: WizardStepComponent = this.steps[this.activeStepIndex + 1];
            this.activeStep.Next.emit();
            nextStep.isDisabled = false;
            nextStep.isActive = true;
            this.activeStep = nextStep;
        }
    }

    public previous(): void {
        if (this.hasPrevStep) {
            const prevStep: WizardStepComponent = this.steps[this.activeStepIndex - 1];
            this.activeStep.Prev.emit();
            prevStep.isDisabled = true;
            // prevStep.isActive = false;
            this.activeStep = prevStep;
        }
    }

    public complete(): void {
        this.activeStep.Complete.emit();
        this._isCompleted = true;
    }
}
